import { DotSeparator } from '@frameio/shared/components/DotSeparator';
import { Box, Spinner, Text, theme } from '@frameio/vapor';
import { IconArrowDown, IconArrowUp } from '@frameio/vapor-icons';
import type { TransferBatch } from '../../../types/uploader';
import { getProgressType } from '../../../utils';
import { ARROW_ICON_CLASSNAME } from '../constants';
import { JobSize } from '../JobSize';
import { ScrollingJob } from '../ScrollingJob';
import TEXT from './generated/TEXT/ChecksumsProgressJobStatus';

TEXT.DEFINE({
  /** Status label when downloading */
  downloading: 'Downloading',
  /** Status label when uploading */
  uploading: 'Uploading',
  /** Status label when generating checksums */
  checksumming: 'Checksumming',
  /** Aria label for loading spinner */
  loadingAriaLabel: 'Loading',
});

export const ChecksumsProgressJobStatus = ({ job }: { job: TransferBatch }) => {
  const bytesTotal = job?.progress?.bytesTotal;
  const progressType = getProgressType(job);

  return (
    <>
      <ScrollingJob>
        {progressType === 'DOWNLOAD' ? (
          <IconArrowDown
            className={ARROW_ICON_CLASSNAME}
            color={theme.colors.icon.interactive.success}
            size={16}
          />
        ) : (
          <IconArrowUp
            className={ARROW_ICON_CLASSNAME}
            color={theme.colors.brand.primary}
            size={16}
          />
        )}
        <Text
          color="body"
          data-testid="job-card--checksums-progress-status-text"
          fontWeight="medium"
          variant="secondary"
        >
          {progressType === 'DOWNLOAD' ? TEXT.downloading : TEXT.uploading}
        </Text>
        <DotSeparator />
        <JobSize bytesTotal={bytesTotal} />
      </ScrollingJob>
      <DotSeparator />
      <Box data-chromatic="ignore" paddingRight={4}>
        <Spinner
          aria-label={TEXT.loadingAriaLabel}
          delay={0}
          isLoading={true}
          size="xx-small"
        />
      </Box>
      <Text color="body" variant="secondary">
        {TEXT.checksumming}
      </Text>
    </>
  );
};
